<template>
  <div style="display: flex; flex-direction: column; gap: 10px">
    <div
      class="rowContent"
      style="padding: 0.8rem 0; gap: 1rem; justify-content: space-between"
    >
      <div class="rowContent">
        <div class="cardTotal" style="background-color: rgb(239, 246, 255)">
          <div class="headerCardTotal">
            <b-icon-box-seam scale="1.3" style="color: rgb(29, 78, 216)" />

            <p style="font-size: 13px; color: rgb(29, 78, 216)">
              Total de Itens
            </p>
          </div>

          <p class="totalValueText" style="color: rgb(29, 78, 216)">
            {{ maskCurrency(this.totals.totalOfItens) }}
          </p>
        </div>

        <div
          class="cardTotal"
          style="background-color: rgba(175, 173, 173, 0.12)"
        >
          <div class="headerCardTotal">
            <b-icon-patch-minus scale="1.5" style="color: #000000c2" />

            <p style="font-size: 13px; color: #000000c2">
              Desconto de produtos
            </p>
          </div>

          <p class="totalValueText" style="color: #000000c2">
            {{ maskCurrency(this.totals.totalOfDiscount) }}
          </p>
        </div>

        <div class="cardTotal" style="background-color: rgb(239, 246, 255)">
          <div class="headerCardTotal">
            <p style="font-size: 15px; color: rgb(29, 78, 216)">$</p>

            <p style="font-size: 13px; color: rgb(29, 78, 216)">
              Total da Venda
            </p>
          </div>

          <p class="totalValueText" style="color: rgb(29, 78, 216)">
            {{ maskCurrency(totals.totalOfSale) }}
          </p>
        </div>

        <div class="cardTotal" style="background-color: rgb(240, 253, 244)">
          <div class="headerCardTotal">
            <b-icon-check2-circle scale="1.4" style="color: #0fbf4d" />

            <p style="font-size: 13px; color: #0fbf4d">Total Pago</p>
          </div>

          <p class="totalValueText" style="color: #0fbf4d">
            {{ maskCurrency(totalBills.paid) }}
          </p>
        </div>

        <div class="cardTotal" style="background-color: rgb(254, 242, 242)">
          <div class="headerCardTotal">
            <b-icon-exclamation-circle
              scale="1.3"
              style="color: rgb(185, 28, 28)"
            />

            <p style="font-size: 13px; color: rgb(185, 28, 28)">
              Total Devedor
            </p>
          </div>

          <p class="totalValueText" style="color: rgb(185, 28, 28)">
            {{ maskCurrency(totals.totalOfSale - totalBills.paid) }}
          </p>
        </div>
      </div>

      <div class="rowContent">
        <div class="cardTotal" style="background-color: #80808000">
          <div class="headerCardTotal">
            <p style="font-size: 15px; color: black">%</p>

            <p style="font-size: 13px; color: black">Aplicar Desconto Total</p>
          </div>

          <div
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 0.5rem;
            "
          >
            <div class="itemToggleDesc">
              <label class="switch col-sm-2 col-md-2 col-lg-2 col-xl-2">
                <input type="checkbox" ref="typeDiscount" v-model="inputDesc" />
                <div class="slider">
                  <span>R$</span>
                  <span>%</span>
                </div>
              </label>
            </div>

            <div>
              <InputMoney
                v-if="!inputDesc"
                label="Desc"
                :labelFixed="true"
                type="text"
                :dataInput.sync="saleDiscount"
                ref="discount"
                isSelectAll
              />

              <InputPercentage
                v-else
                label="Desc"
                :labelFixed="true"
                type="text"
                :dataInput.sync="saleDiscount"
                ref="discount"
                isSelectAll
              />
            </div>

            <button
              class="btnsSale"
              @click="$bvModal.show('check-discount')"
              :disabled="isLoading"
            >
              <b-spinner v-if="isLoading" class="spin" />

              <p v-else>aplicar</p>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="containerItens">
      <div class="descriptionSection">
        <b-icon-credit-card />
        <span> Informações de pagamentos</span>
      </div>

      <GenerateBills
        ref="generateBillsRef"
        :idCliente="sale.idCliente"
        :saleId="sale.id"
        :idFuncionario="sale.idFuncionario"
        :typeItem="{ typeId: 'idVenda', id: sale.id }"
        :totalValue="Math.round(this.totalValue * 100) / 100"
        :allPaymentsTypes="allPaymentsTypes"
        :isClear="toggleToClearBills"
        @getBills="handleGetBills"
        @newAccountReceiptBillCreated="getAllReceiptBill"
        @listPaymentMethods="getAllPayment"
      />
    </div>

    <ModalConfirm
      modalName="check-discount"
      title="Aplicar desconto total nos items ?"
      subtitle="Ao aplicar o desconto total irá sobrescrever os descontos unitários já informados!"
      rightButtonText="Não"
      leftButtonText="Sim, aplicar"
      typeModal="info"
      headerIcon="b-icon-patch-exclamation-fill"
      :leftButtonClick="applyDiscountInProducts"
    />
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

import GenerateBills from "../../components/GenerateBill/index.vue";
import InputMoney from "../UI/CustomInputs/InputMoney.vue";
import InputPercentage from "../UI/CustomInputs/InputPercentage.vue";
import ModalConfirm from "../Modals/ModalConfirm.vue";

import ServiceProductSale from "../../services/serviceProductSale";
import { mascaraMoeda, maskCurrency } from "../../utils/maskMoney";

export default {
  props: {
    sale: {
      type: Object,
      default: () => ({
        id: "",
        idCliente: "",
        idFuncionario: "",
        tipoDesconto: "Valor Monetário",
      }),
    },
    totalValue: {
      type: Number,
    },
    allPaymentsTypes: {
      type: Array,
    },
    toggleToClearBills: {
      type: Boolean,
    },
    totals: {
      type: Object,
      default: () => ({
        totalOfItens: 0,
        totalOfDiscount: 0,
        totalOfSale: 0,
      }),
    },
  },
  components: {
    GenerateBills,
    InputMoney,
    InputPercentage,
    ModalConfirm,
  },
  data() {
    return {
      mascaraMoeda: mascaraMoeda,
      maskCurrency: maskCurrency,
      saleDiscount: 0,
      inputDesc: false,
      existsBills: false,
      isLoading: false,
      totalBills: {
        paid: 0,
        debtor: 0,
      },
    };
  },
  methods: {
    ...mapMutations(["TOGGLE_DISCOUNT"]),
    async applyDiscountInProducts() {
      try {
        this.isLoading = true;

        if (this.existsBills) {
          return this.$toast.open({
            message: "Parcelas já lançadas, não é possível aplicar desconto",
            type: "info",
          });
        }

        const payload = {
          desconto: this.saleDiscount,
          tipoDesconto: this.inputDesc ? "Porcentagem" : "Valor Monetário",
        };

        await ServiceProductSale.applyDiscountInProducts(this.sale.id, payload);

        this.TOGGLE_DISCOUNT(this.inputDesc);

        this.$emit("findProducts");

        this.$toast.open({
          message: "Desconto aplicador nos itens",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao aplicar o desconto nos produtos",
          type: "info",
        });
      } finally {
        this.isLoading = false;
      }
    },
    handleGetBills(bills) {
      if (bills.length) {
        this.existsBills = true;

        const result = bills.reduce(
          (prev, bill) => {
            prev.paid += bill.valorPago;
            prev.debtor += bill.valorRestante;

            return prev;
          },
          { paid: 0, debtor: 0 }
        );

        this.totalBills = result;
      } else {
        this.existsBills = false;
        this.totalBills = { paid: 0, debtor: 0 };
      }
    },
    getAllPayment() {
      this.$emit("getAllPayment");
    },
    getAllReceiptBill() {
      this.$emit("getAllReceiptBill");
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.sale.tipoDesconto === "Porcentagem") {
        this.$refs.typeDiscount.checked = true;
        this.inputDesc = true;
      } else {
        this.inputDesc = false;
        this.$refs.typeDiscount.checked = false;
      }

      this.saleDiscount = this.sale.desconto;
      this.$refs.discount.valueInput = this.sale.desconto;
    });
  },
  filters: {},
  computed: {
    ...mapState(["discountIsChecked"]),
  },
  beforeDestroy() {},
};
</script>

<style scoped>
.containerItens {
  border: 1px solid #c8dfd5;
  border-radius: 5px;
  padding: 10px;
}

.descriptionSection {
  gap: 10px;
  border-radius: 8px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.descriptionSection span {
  font-size: 0.8rem;
}

.rowContent {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.cardTotal {
  min-width: 150px;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem 0.8rem;
  box-shadow: 0 0 0px 1px #0000002d;
  border-radius: 8px;
}

.cardTotal p {
  margin: 0;
}

.headerCardTotal {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.totalValueText {
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 1px;
}

.itemToggleDesc {
  width: 50px;
  height: 100%;
}

.switch {
  height: 100%;
  margin: 0;
  font-size: 14px;
  position: relative;
  display: inline-block;
}

.slider {
  position: absolute;
  cursor: pointer;
  left: 0;
  top: 0;
  bottom: 0;
  background-color: #d9d9d9;
  color: #ffffff;
  border-radius: 5px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  transition: 0.4s;
  width: 50px !important;
  height: 95%;
  font-size: 8px;
}

.slider:before {
  position: absolute;
  content: "R$";
  font-size: 10px;
  height: 82%;
  width: 44%;
  left: 6%;
  border-radius: 5px;
  background-color: #00aa62;
  color: white;
  display: grid;
  align-content: center;
  justify-content: center;
  transition: 0.4s;
  font-weight: bold;
}

.slider:after {
  content: "";
  position: absolute;
  z-index: -1;
}

.switch input:checked + .slider {
  background-color: #d9d9d9;
  color: white;
}

.switch input:checked + .slider:before {
  content: "%";
  background-color: #00aa62;
  transform: translateX(100%);
  color: white;
}

.switch input {
  display: none;
}

.btnsSale {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  background-color: #0fbf4d;
  width: 55px;
  height: 30px;
  border: none;
  color: white;
  font-size: 12px;
}

.spin {
  color: white;
  width: 20px;
  height: 20px;
}
</style>